import type { PermissionModel } from '@snowit/types/permissions';

import useFirebase from '@snowit/firebase';

/**
 * This functions should not require special permissions
 */
export default () => {
  const firebase = useFirebase();

  const getPermissions = async (): Promise<PermissionModel[]> => {
    return firebase.query<PermissionModel>({
      collectionName: 'permissions',
      filters: (q) => q.limit(0),
    });
  };

  return {
    getPermissions,
  };
};
